import { render, staticRenderFns } from "./ViewLabourerPaymentItemPage.vue?vue&type=template&id=16eb1532&scoped=true&"
import script from "./ViewLabourerPaymentItemPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./ViewLabourerPaymentItemPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eb1532",
  null
  
)

export default component.exports